import Model from "~/models/_Model";
import Task from "./Task";
import Log from "./Log";
import File from "./File";

export default class System extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/systemsmanager";
  }

  // Set the resource route of the model
  resource() {
    return "systems";
  }

  relations() {
    return {
      tasks: Task,
      last_task: Task,
      logs: Log,
    };
  }

  files() {
    return this.hasMany(File);
  }

  get display_status() {
    if (!this.tasks || this.tasks.length === 0) {
      return this.status;
    }
    const badTask = this.tasks.find((task) => {
      return task.status == "Error";
    });
    return badTask ? badTask.status : this.status;
  }

  get display_status_icon() {
    switch (this.display_status) {
      case "Error":
        return "error";
      default:
        return "check";
    }
  }

  get display_status_color() {
    switch (this.display_status) {
      case "Running":
        return "positive";
      case "Error":
        return "negative";
      default:
        return "info";
    }
  }

  get display_active_icon() {
    return this.active ? "check" : "error";
  }

  get display_active_color() {
    return this.active ? "positive" : "negative";
  }
}
